import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { auth, getOnboardingForm, } from "../firebase";
import { Button, Checkbox, Spinner, Text, Image, VerticalStack, Divider, HorizontalStack, AlphaCard, Avatar, HorizontalGrid, Select, RadioButton, TextField, Icon, Box } from "@shopify/polaris";
import { AddressElement, useElements } from '@stripe/react-stripe-js';

import SimpleTemplate from "../templates/SimpleTemplate";
import ClassicTemplate from "../templates/ClassicTemplate";
import LpForm from "../templates/LpForm";

const MAPS_KEY = 'AIzaSyACFv1SiRtvQ6IsAwoRJZeiT8c_UZp9pFQ'

export default function Onboarding() {
  const elements = useElements()

  const subdomain = window.location.hostname.split('.')[0];

  const urlParams = new URLSearchParams(window.location.search);
  const ID = urlParams.get('id');

  const [localForm, setLocalForm] = useState({
    defaultFields: {
      name: '',
      email: '',
      primaryPlatform: 'instagram',
      handle: ''
    },
    customFields: {

    },
  });

  console.log('localForm', localForm)

  const {
    data: form,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['getForm', ID],
    queryFn: () => getOnboardingForm(ID, subdomain, setLocalForm),
  });

  useEffect(() => {
    if (form) {
      const initialCustomValues = {}
      Object.entries(form.customFields).forEach(([key, value]) => {
        if (value.type === 'dropdown') {
          initialCustomValues[key] = value.options[0].label
        }
      })
      setLocalForm({
        ...localForm,
        customFields: initialCustomValues
      })
      if (form.storeData?.name) {
        window.document.title = form.storeData.name
      }
    }
  }, [form])

  if (isLoading) {
    return (
      <HorizontalStack align="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="800px" width="500px">
          <AlphaCard>
            <HorizontalStack align="center">
              <Spinner />
            </HorizontalStack>
          </AlphaCard>
        </Box>
      </HorizontalStack>
    )
  } else if (error) {
    return (
      <HorizontalStack align="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="800px" width="500px">
          <AlphaCard>
            <HorizontalStack align="center">
              <Text color="critical">{error.message}</Text>
            </HorizontalStack>
          </AlphaCard>
        </Box>
      </HorizontalStack>
    )
  } else if (!form) {
    return (
      <HorizontalStack align="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="800px" width="500px">
          <AlphaCard>
            <VerticalStack inlineAlign="center">
              <Text variant="heading2Xl">404</Text>
              <Text>Form Not Found</Text>
            </VerticalStack>
          </AlphaCard>
        </Box>
      </HorizontalStack>
    )
  } else {
    if (form?.template === 'Simple') {
      return (
        <SimpleTemplate fields={form} setLocalFields={setLocalForm} />
      )
    } else if (form?.template === 'Classic') {
      return (
        <ClassicTemplate fields={form} setLocalFields={setLocalForm} />
      )
    } else {
      console.log('localForm', localForm)
      return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '50%', maxWidth: '600px', minWidth: '400px', paddingTop: '20px' }}>
            <AlphaCard>
              <LpForm formID={form?.id} customFields={form?.customFields} setCustomFields={(key, value) => {
                setLocalForm({
                  ...localForm,
                  customFields: {
                    ...localForm.customFields,
                    [key]: value
                  }
                })
              }} />
            </AlphaCard>
          </div>
        </div>
      )

    }
  }
}
